export const MIX_PANEL_PAGE_NAME = 'Tailored Homepage';
